
export enum NodeTypeCd {
	CARTAGE_AGENT = 'CartageAgent',
	CUSTOMER_LOCATION = 'CustomerLocation',
	DROP_LOCATION = 'DropLocation',
	SERVICE_CENTER = 'ServiceCenter'}

